module.exports = __webpack_public_path__ + "img/对号.6713ca39.svg";